/* jshint ignore:start */
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                searchForm();
                reorderSlider();
                itemsSlider();
                footerIcons();

                //  videoPosterPlay();
                scrollToHash();
                fileNameContactform(); // and other forms behaviors
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                observeBoxesHeight();
                autoplayVideoOnScrollTo();
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS

            }
        },
        //canviar el gui per subguio
        'post_type_archive_noticias': {
            init: function () {
                ajaxFilterNoticias();
            }
        },
        'tax_categorias_noticias': {
            init: function () {
                ajaxFilterNoticias();
            }
        },
        // downloads
        'page_template_template_downloads': {
            init: function () {
                ajaxFilterDocumento();
                sortBrandsByArea();
            }
        },
        // single division
        'single_division': {
            init: function () {
                ajaxProjects();
                functionsDivision();
                observeVideoHeight();
            }
        },
        // taxonomy marca
        'tax_marca': {
            init: function () {
                reorderSubSections();
            }
        }



    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };


    /* var videoPosterPlay = function() {
        // poster frame click event
        $(document).on('click','.btn-video',function(ev) {
            ev.preventDefault();
            var $poster = $(this);
            var $wrapper = $poster.closest('.js-videoWrapper');
            videoPlay($wrapper);
        });

        // play the targeted video (and hide the poster frame)
        function videoPlay($wrapper) {
            var $iframe = $wrapper.find('.js-videoIframe');
            var src = $iframe.data('src');
            // hide poster
            $wrapper.addClass('videoWrapperActive');
            $iframe.css('z-index', 14);
            $('.item-video img').addClass('hide');
            $(".btn-video").addClass('hide');
          //  $(".item-video .hero-texts").addClass('hide');

            // add iframe src in, starting the video
            $iframe.attr('src',src);
        }

        // stop the targeted/all videos (and re-instate the poster frames)
        function videoStop($wrapper) {
            // if we're stopping all videos on page
            if (!$wrapper) {
                var $wrapper = $('.js-videoWrapper');
                var $iframe = $('.js-videoIframe');
                // if we're stopping a particular video
            } else {
                var $iframe = $wrapper.find('.js-videoIframe');
            }
            // reveal poster

            $('.item-video img').addClass('hide');
            $(".btn-video").removeClass('hide');
          //  $(".item-video .hero-texts").removeClass('hide');
            // remove youtube link, stopping the video from playing in the background
            $iframe.attr('src','');
        }
    }
*/
    var scrollToHash = function () {

        var jump = function (e) {
            if (e) {
                e.preventDefault();
                var target = $(this).attr("href");
            } else {
                var target = location.hash;
            }

            $('html,body').animate({
                scrollTop: $(target).offset().top - 40
            }, 1000, function () {
                location.hash = target;
            });
        }

        //$('html, body').hide()

        $('.tax-marca a[href^=#]').bind("click", jump);

        if (location.hash) {
            setTimeout(function () {
                $('html, body').scrollTop(0).show()
                jump()
            }, 0);
        } else {
            $('html, body').show()
        }

    }


    var ajaxProjects = function () {

        $('.menu-secondary ul li').on('click', function () {

            $(this).siblings().removeClass("active");
            $(this).addClass("active");
            $("#slider-projects-division").addClass("fantasma");
            $.ajax({
                type: "GET",
                url: ajax_object.ajaxurl, // Pon aquí tu URL
                data: {
                    action: "filter_projectes",
                    termid: $(this).data("term")
                },
                error: function (response) {
                    console.log('error');
                },
                success: function (response) {
                    console.log("fet");
                    // Actualiza el mensaje con la respuesta

                    $('#slider-projects-division').remove();

                    $(response).insertAfter($('nav.menu-secondary'));
                    reorderSlider();
                    itemsSlider();
                }
            })

        });


        $('.single-division .menu-secondary ul li').on('click', function () {

            $('html, body').animate({
                scrollTop: $('.menu-secondary').offset().top - 110
            }, 500);

        });


    }

    //contact form 7 requireds canviar (*) per * vermellet
    //en el cas de checkboxes i option lists es fa per css amb un :after
    var fileNameContactform = function () {
        // mostrar nom arxiu a formulari rrhh a pujada de curriculum
        $('input[type="file"]').change(function (e) {
            var fileName = e.target.files[0].name;
            $('.upload-field .wpcf7-form-control-wrap').prepend('<span class="fileinfo"></span>');
            var currentLang = $('html').attr('lang');
            console.log("lang " + currentLang);
            if (currentLang == 'en-US') {
                fileLabel = "File selected";
            } else if (currentLang == 'es-ES') {
                fileLabel = "Fichero seleccionado";
            } else if (currentLang == 'pt-PT') {
                fileLabel = "Arquivo selecionado";
            }

            $('.upload-field .fileinfo').html('<span>' + fileLabel + ': ' + fileName + " &nbsp;</span>");
        });
    }


    var cleanerRequireds = function () {
        $('.wpcf7-form label, .wpcf7-form span').each(function () {
            origHtml = $(this).html();
            newHtml = origHtml.replace('(*)', '<span class="req">*</span>');
            $(this).html(newHtml);
        });

        // link a condicions legals a dins el text dels checkbox
        // oju: themurl es defineix a head.php de manera global amb bloginfo(url)

        // form contacto
        $('[lang="es-ES"] .wpcf7-form .aceptar-condiciones .wpcf7-list-item-label').html('Acepto las condiciones de uso y ' +
            '<a href="' + themeurl + '/aviso-legal">política de privacidad.</a>');

        // form rrhh
        $('[lang="es-ES"] .wpcf7-form .aceptar-condiciones-y-ofertas-empleo .wpcf7-list-item-label').html('Acepto las condiciones de uso y ' +
            '<a href="' + themeurl + '/aviso-legal">política de privacidad</a>' +
            ', y doy mi consentimiento a Frigicoll S.A. para el envío de ofertas de empleo.');

        // form profesionales
        $('[lang="es-ES"] .wpcf7-form .aceptar-condiciones-profesionales .wpcf7-list-item-label').html('He leído y acepto la ' +
            '<a href="' + themeurl + '/aviso-legal">política de privacidad</a>' +
            ' y doy mi consentimiento a Frigicoll S.A, para el envio de ' +
            'información vinculada a la intranet de profesionales.');

        // portugues

        // form contacto
        $('[lang="pt"] .wpcf7-form .aceptar-condiciones .wpcf7-list-item-label').html('Aceito as condições de uso e a ' +
            '<a href="' + themeurl + '/pt/aviso-legal">política de privacidade.</a>');

        // form rrhh
        $('[lang="pt"] .wpcf7-form .aceptar-condiciones-y-ofertas-empleo .wpcf7-list-item-label').html('Aceito as condições de uso e a ' +
            '<a href="' + themeurl + '/pt/aviso-legal">política de privacidade.</a>');

        // form profesionales
        $('[lang="pt"] .wpcf7-form .aceptar-condiciones-profesionales .wpcf7-list-item-label').html('Aceito as condições de uso e a ' +
            '<a href="' + themeurl + '/pt/aviso-legal">política de privacidade.</a>' +
            ' Dou o meu consentimento à Frigicoll S.A., para o envio de informação relativa à Intranet para profissionais');




        // TO DO: ANGLES (no se si es "en" o "en-GB")



    }

    var searchForm = function () {
        $('.site-header .search-button').on("click", function (event) {
            //console.log("click 2");
            $(".site-header #search").toggleClass("open");
            $('.site-header #search > form > input[type="text"]').focus();
        });

        $("#search, #search button.close").on("click keyup", function (event) {

            if (
                event.target === this ||
                event.target.className === "close" ||
                event.keyCode === 27
            ) {
                $(this).removeClass("open");
            }
        });

        $("form").submit(function (event) {
            //event.preventDefault();
            //return false;
        });

    };

    var reorderSlider = function () {
        // comprovem si hi ha algun item al dom amb atribut de ordre especial

        if ($('[data-feat-proj-home-order]').length) {

            //proyectos-slider
            for (items = 1; items < 11; items++) {
                $('.home [data-feat-proj-home-order="' + items + '"]').appendTo('.proyectos-slider');
            }
        }

        if ($('[data-proj-slide-order]').length) {

            for (items = 1; items < 16; items++) {
                $('.single-division [data-proj-slide-order="' + items + '"]').appendTo('.proyectos-slider');
            }

        }

    };

    // reordering subsections in tax marca when term is hosteleria
    // en base a custom field fri_subtype_suborder del grup Campos taxonomia marca
    var reorderSubSections = function () {

        for (items = 1; items < 11; items++) {
            $('.section-hosteleria#frio .row-hosteleria [data-subtype-suborder="' + items + '"]').appendTo('.section-hosteleria#frio .row-hosteleria');
            $('.section-hosteleria#coccion-cocinas .row-hosteleria [data-subtype-suborder="' + items + '"]').appendTo('.section-hosteleria#coccion-cocinas .row-hosteleria');
            $('.section-hosteleria#coccion-hornos .row-hosteleria [data-subtype-suborder="' + items + '"]').appendTo('.section-hosteleria#coccion-hornos .row-hosteleria');
            $('.section-hosteleria#lavado .row-hosteleria [data-subtype-suborder="' + items + '"]').appendTo('.section-hosteleria#lavado .row-hosteleria');
        }

    }

    var itemsSlider = function () {

        var hero = $('.hero-slider');
        hero.owlCarousel({
            autoplay: 2000,
            items: 1,
            loop: true,
            nav: true,
            autoHeight: true,
            autoHeightClass: 'owl-height',
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"]
        });

        var heroProjects = $('.hero-slider-projects');
        heroProjects.owlCarousel({
            autoplay: 2000,
            loop: true,
            items: 1,
            nav: true,
            autoHeight: true,
            autoHeightClass: 'owl-height',
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"]
        });

        hero.owlCarousel({
            autoplay: 2000,
            loop: true,
            items: 1,
            nav: true,
            autoHeight: true,
            autoHeightClass: 'owl-height',
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"]
        });

        var owl = $('.proyectos-slider');
        owl.owlCarousel({
            autoplay: 2000,
            loop: true,
            items: 1,
            nav: true,
            dots: false,
            autoHeigt: true,
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"],
            onInitialized: function (event) {
                var items = event.item.count;
                if (items <= 1) {
                    this.options.mouseDrag = false;
                    this.options.touchDrag = false;
                    $('.proyectos-slider .owl-stage').addClass("single");
                }
            }
            //onTranslated:  //counter -When the translation of the stage has finished.
        });



        var noticias = $('.noticias-slider');
        noticias.owlCarousel({
            autoplay: false,
            items: 1,
            nav: true,
            dots: false,
            loop: true,
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"],
            //onInitialized: counter, //When the plugin has initialized.
            //onTranslated: counter //When the translation of the stage has finished.
        });

        var multimedias = $('.multimedia-slider');
        multimedias.owlCarousel({
            autoplay: false,
            loop: true,
            items: 1,
            nav: true,
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"],
            //onInitialized: counter, //When the plugin has initialized.
            //onTranslated: counter //When the translation of the stage has finished.
        });

        var proyectos = $('.proyectos-slider-tres');
        proyectos.owlCarousel({
            autoplay: false,
            nav: true,
            margin: 50,
            loop: true,
            navText: ["<i class='arr-left'></i>", "<i class='arr-right'></i>"],
            //onInitialized: '', //counterMultiple When the plugin has initialized.
            //onTranslated: '', //counterMultiple When the translation of the stage has finished.
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                    slideBy: 2,
                },
                1024: {
                    items: 3,
                    slideBy: 3
                }
            }
        });

        /* ja no fem servir la funcio counter ni counterMultiple als slides de projectes ni projectes destacats */
        /* pel que fa als slides de noticies i o activitats, no han dit res de treure la numeracio */

        function counterMultiple(event) {
            //console.log("hola2");
            var element = event.target; // DOM element, in this example .owl-carousel
            var section = '#' + $(element).closest('section').attr('id');
            //console.log("section " + section);
            $(section + " .num").insertAfter(section + " .owl-carousel .owl-nav .owl-prev");
            var winWidth = $(window).width();

            if (winWidth > 767 && winWidth < 1024) {
                var items = event.item.count; // Number of items
                var item = event.item.index + 1; // Position of the current item
                var lastItemOfCurrentPage = item + 1;

                $(section + ' .num .active-item').html(item + "-" + lastItemOfCurrentPage);
                $(section + ' .num .total-items').html(items);
            } else if (winWidth > 1023) {
                var items = event.item.count; // Number of items
                var item = event.item.index + 1; // Position of the current item
                var lastItemOfCurrentPage = item + 2;

                $(section + ' .num .active-item').html(item + "-" + lastItemOfCurrentPage);
                $(section + ' .num .total-items').html(items);
            } else {
                var items = event.item.count; // Number of items
                var item = event.item.index + 1; // Position of the current item

                $(section + ' .num .active-item').html(item);
                $(section + ' .num .total-items').html(items);
            }
            // pages     = event.page.count;

        }

        function counter(event) {
            var element = event.target; // DOM element, in this example .owl-carousel
            var section = '#' + $(element).closest('section').attr('id');
            //console.log("section " + section);
            $(section + " .num").insertAfter(section + " .owl-carousel .owl-nav .owl-prev");
            var items = event.item.count; // Number of items
            var item = event.item.index + 1; // Position of the current item
            $(section + ' .num .active-item').html(item);
            $(section + ' .num .total-items').html(items);
        }

    };

    var ajaxFilterNoticias = function () {

        ajaxLoadNoticias();

        $('.categorias-noticias-list').on('click', 'li', function () {

            var button = $('.load-more-noticias');

            var filter = $(this),
                data = {
                    'action': 'filter_noticias',
                    'id': filter.attr('data-tax'),
                    'paged': button.attr('data-current'),
                    'max_pages': button.attr('data-max'),
                };

            $.ajax({
                url: ajax_object.ajaxurl, // AJAX handler
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {},
                success: function (data) {

                    $('.categorias-noticias-list li').removeClass('is-checked');
                    filter.addClass('is-checked');

                    if (data) {

                        $('.list-noticias-container').html(data); // insert new posts

                        if (button.attr('data-current') == button.attr('data-max')) {
                            button.remove(); // if last page, remove the button
                        }

                        ajaxLoadNoticias();

                    }
                }
            });

        });

        /* prefiltrat de noticies per GET , incoming link des d'slideshow noticias al single division */

        function GET_var(var_name) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == var_name) {
                    return pair[1];
                }
            }
            return (false);
        }

        var get_variable = GET_var("tema");
        var tema;
        if (get_variable !== '') {
            $('[data-tax-slug=' + get_variable + ']').click();
        }

    }

    var ajaxLoadNoticias = function () {

        $('.load-more-noticias').on('click', function () {

            var button = $(this),
                data = {
                    'action': 'load_noticias',
                    'term': button.attr('data-tax'),
                    'page': button.attr('data-current'),
                    'max_pages': button.attr('data-max'),
                };

            $.ajax({
                url: ajax_object.ajaxurl, // AJAX handler
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {
                    button.addClass('loading');
                },
                success: function (data) {

                    if (data) {
                        button.removeClass('loading');
                        $('.list-noticias').append(data); // insert new posts

                        var current_page = button.attr('data-current');
                        var max_page = button.attr('data-max');

                        current_page++;
                        button.attr('data-current', current_page);

                        if (current_page == max_page) {
                            button.remove(); // if last page, remove the button
                        }
                    }
                }
            });
        });
    }

    // filtre de documents i descarregues, comportament de les combo boxes

    //show every dropdown, but hide first all
    $('.frigi-form-select').bind('click', function () {

        if ($(this).hasClass('open')) {
            var open = true;
        }
        $('.frigi-form-select').removeClass('open');
        $('.f-dropdown').removeClass('z-index-3');

        if (open) {
            console.log("opened");
            $(this).removeClass('open');
        } else {
            $(this).toggleClass('open');
            $('.f-dropdown').removeClass('z-index-3');
            $(this).parent().toggleClass('z-index-3');
        }
    });
    //hide every dropdown when click outside
    $(document).on("click", function (event) {
        var $trigger = $(".frigi-form-select");
        if (!$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
            $('.frigi-form-select').removeClass('open');
            $('.f-dropdown').removeClass('z-index-3');
        }
    });

    txtLineaOrig = $('#dropdown-linea .frigi-form-select').text();

    $('#dropdown-linea .frigi-form-option').bind('click', function () {
        valor = $(this).attr('data-id');
        if (valor < 0) {
            texto = txtLineaOrig;
            $('#linea').val(-1);
            $('#dropdown-marca li').removeClass('d-none');
            $('#dropdown-linea').removeClass('setted');
        } else {

            //$('#dropdown-marca li:nth-child(1)').click();
            texto = $(this).text();

            //amagarem les subcategories que no siguin filles directes
            //exemple, problema, tenim calefaccio > liebherr, xo tambe refrigeracion > liebherr

            selectedParent = $(this).attr('data-term-dad');
            //console.log('Selected parent: "'+selectedParent+'"');
            $('#dropdown-marca li').addClass('d-none');
            $('#dropdown-marca li[data-term-dad="' + selectedParent + '"]').removeClass('d-none');
            $('#dropdown-linea').addClass('setted');
        }
        $('#linea').val(valor);
        $('#dropdown-linea .frigi-form-select').removeClass('open').text(texto);


    });

    txtMarcaOrig = $('#dropdown-marca .frigi-form-select').text();

    $('#dropdown-marca .frigi-form-option').bind('click', function () {
        valor = $(this).attr('data-id');
        if (valor < 0) {
            texto = txtMarcaOrig;
            $('#marca').val(-1);
            $('#dropdown-marca').removeClass('setted');
        } else {
            texto = $(this).html();
            $('#dropdown-marca').addClass('setted');
        }
        $('#marca').val(valor);
        $('#dropdown-marca .frigi-form-select').removeClass('open').html(texto);
    });

    txtTipoOrig = $('#dropdown-tipo .frigi-form-select').text();

    $('#dropdown-tipo .frigi-form-option').bind('click', function () {
        valor = $(this).attr('data-id');
        if (valor < 0) {
            texto = txtTipoOrig;
            $('#tipo').val(-1);
            $('#dropdown-tipo').removeClass('setted');
        } else {
            texto = $(this).text();
            $('#dropdown-tipo').addClass('setted');
        }
        $('#tipo').val(valor);
        $('#dropdown-tipo .frigi-form-select').removeClass('open').text(texto);
    });

    // filtre de documents i descarregues - funcions ajax


    function loadBussinesLine() {
        console.log("he entrat2");
        var button = $('.load-more-documentos');

        var filter = $(this),
            data = {
                'action': 'filter_documentos',

                'tax1': $('#linea').val(),
                'tax2': $('#marca').val(),
                'tax3': $('#tipo').val(),
                /*
                'id': filter.attr('data-tax'),
                */
                'paged': button.attr('data-current'),
                'max_pages': button.attr('data-max'),
            };

        $.ajax({
            url: ajax_object.ajaxurl, // AJAX handler
            data: data,
            type: 'POST',
            beforeSend: function (xhr) {
                $('main').addClass('loading');
            },
            success: function (data) {

                if (data) {

                    $('#results').html(data); // insert new posts
                    $('main').removeClass('loading');

                    if (button.attr('data-current') == button.attr('data-max')) {
                        button.remove(); // if last page, remove the button
                    }

                    ajaxLoadMoreDocs();
                }

            },
            error: function () {
                console.log('fail!');
            }
        });

    }

    var ajaxFilterDocumento = function () {

        ajaxLoadMoreDocs();

        console.log("executat!");
            loadBussinesLine();
        

        $('.frigi-form-option').bind('click', function () {
            loadBussinesLine();
           
        });

    }

    /* carregar mes docs i paginacio */

    var ajaxLoadMoreDocs = function () {

        // Treiem de dins de la llista el boto de carregar mes
        $('#results + .load-more-documentos-wrapper').remove(); // borrar anterior
        $('.load-more-documentos-wrapper').insertAfter('#results');

        $('.load-more-documentos').bind('click', function () {

            //console.log('LoadMordocsClick');

            var button = $(this),
                data = {
                    'action': 'load_documentos',
                    'tax1': $('#linea').val(),
                    'tax2': $('#marca').val(),
                    'tax3': $('#tipo').val(),
                    //'term': button.attr('data-tax'),
                    'page': button.attr('data-current'),
                    'max_pages': button.attr('data-max'),
                };

            $.ajax({
                url: ajax_object.ajaxurl, // AJAX handler
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {
                    $('main').addClass('loading');
                },
                success: function (data) {

                    if (data) {
                        $('main').removeClass('loading');
                        $('#results').append(data); // insert new posts

                        var current_page = button.attr('data-current');
                        var max_page = button.attr('data-max');

                        current_page++;
                        button.attr('data-current', current_page);



                        if (current_page == max_page) {
                            button.remove(); // if last page, remove the button
                        }
                    }
                }
            });
        });
    }


    // ordenar el select de filtre de documents de marca
    // ordenarem les marques per linia de negoci
    var sortBrandsByArea = function () {

        // primer agrupem les marques per area de negoci

        /*

        dintre del dropdown marca hi han aquests containers

        <div class="brand-group climatizacion"></div>
        <div class="brand-group domestico"></div>
        <div class="brand-group transporte-refrigerado"></div>
        <div class="brand-group hosteleria"></div>
        <div class="brand-group refrigeracion"></div>

        */

        $('li[data-term-dad="climatizacion"]').appendTo('.brand-group.climatizacion');
        $('li[data-term-dad="domestico"]').appendTo('.brand-group.domestico');
        $('li[data-term-dad="transporte-refrigerado"]').appendTo('.brand-group.transporte-refrigerado');
        $('li[data-term-dad="hosteleria"]').appendTo('.brand-group.hosteleria');
        $('li[data-term-dad="refrigeracion"]').appendTo('.brand-group.refrigeracion');




        $('.brand-group').each(function () {

            //console.log( $(this).attr('class') );

            var $list = $(this);
            var $listLi = $('li', $list);

            $listLi.sort(function (a, b) {
                var keyA = $(a).attr('data-name');
                var keyB = $(b).attr('data-name');

                return (keyA > keyB) ? 1 : 0;

            });

            $.each($listLi, function (index, row) {
                $list.append(row);
                //console.log(row);
            });

        });
    }

    var functionsDivision = function () {
        // agafem el link directe a la categoria de noticies actual
        var categoryDestination = $('.post-category a').attr('href');

        // link ver todo slide actualidad, fa clic sobre l altre ja existent
        $('.btn-vertodo').click(function (e) {
            console.log('cliqui');
            e.preventDefault();

            window.location.href = categoryDestination;
        });
    }

    var observeVideoHeight = function () {
        // seccio videos linea negocio
        // mesurem alcada i la igualem a l slider d actualitat
        var videoheight = 328;

        function getVideoHeight() {
            if ($('.videoWrapper').length) {
                videoheight = $('.videoWrapper').outerHeight();
            }
            if ($('.video-col').length) {
                videoheight = $('.video-col .multimedia-block').outerHeight();
            }

            //console.log('Video height:' + videoheight);
            $('.featured-news-medium .slide-item').css('height', videoheight);
        }

        $(window).resize(function () {
            setTimeout(getVideoHeight, 500);
        });
        $(document).ready(function () {
            setTimeout(getVideoHeight, 500);
        });
    }

    var observeBoxesHeight = function () {
        // seccio videos linea negocio
        // mesurem alcada i la igualem a l slider d actualitat
        var minboxheight = 328;

        function getBoxesHeight() {
            if ($('#slider-projects-home').length) {
                minboxheight = $('#slider-projects-home .proyectos-slider').outerHeight();
                //console.log('Projects slide height '+minboxheight);
            }
            $('.featured-news-medium .slide-item').css('height', minboxheight);
        }

        $(window).resize(function () {
            setTimeout(getBoxesHeight, 500);
        });
        $(document).ready(function () {
            setTimeout(getBoxesHeight, 500);
        });
    }

    var autoplayVideoOnScrollTo = function () {
        var videoplaying = false;
        var homevideotop = $('.big-video').offset().top;


        //console.log('Video top '+homevideotop);

        $(document).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > (homevideotop - 150) && !videoplaying) {
                videoplaying = true;
                /*
                GOOGLE HA DESHABILITAT LA FEATURE AUTOPLAY SI NO ES UN VIDEO MUTED
                */
                $("#frigicollHomeVideo")[0].src += "&autoplay=1";

            }
        });
    }

    var footerIcons = function () {

        // to do: fer que els iconos de xarxes socials es puguin administrar via un repeater field

        iconosSocialsClima = '<div class="socicons">\
        <a class="fa fa-facebook-square" href="https://www.facebook.com/MideaSpain/" target="_blank" rel="nofollow"></a>\
        <a class="fa fa-twitter" href="https://twitter.com/mideaspain/" target="_blank" rel="nofollow"></a>\
        <a class="fa fa-instagram" href="https://www.instagram.com/mideaspain/" target="_blank" rel="nofollow"></a>\
        <a class="fa fa-youtube" href="https://www.youtube.com/channel/UCE1Iiyi2Tb-AZ8EA4CDTyWA/videos" target="_blank" rel="nofollow"></a>\
        </div>';

        $('.footer .menu-item-170').append(iconosSocialsClima);

        iconosSocialsDomestic = '<div class="socicons">\
        <a class="fa fa-facebook-square" href="https://www.facebook.com/LiebherrElectrodomesticos/" target="_blank" rel="nofollow"></a>\
        <a class="fa fa-twitter" href="https://twitter.com/Liebherr_es" target="_blank" rel="nofollow"></a>\
        <a class="fa fa-instagram" href="https://www.instagram.com/liebherr_es/" target="_blank" rel="nofollow"></a>\
        </div>';

        $('.footer .menu-item-169').append(iconosSocialsDomestic);
    }

    // Load Events
    $(document).ready(UTIL.loadEvents);




    $(document).ready(function () {
        const divisionSelect = $('#div');
        const marcaSelect = $('#marca');
        const marcaContainer = $('#marca-container');

        // Función para mostrar/ocultar el select de "Marca"
        function toggleMarcaSelect() {
            if (divisionSelect.val() === 'climatizacion') {
                marcaContainer.show(); // Mostrar
            } else {
                marcaContainer.hide();  // Ocultar
                marcaSelect.val([]);   // Deseleccionar todas las marcas
                marcaSelect.trigger('change'); // Actualizar el select para reflejar el cambio
            }
        }

        // Ejecutar la función al cargar la página (en caso de que ya haya una selección)
        toggleMarcaSelect();

        // Añadir un listener para detectar cambios en el select de "División"
        divisionSelect.on('change', toggleMarcaSelect);
    });




})(jQuery); // Fully reference jQuery after this point.
